import {BrowserRouter as Router} from 'react-router-dom';
import './App.css';
import AppRouters from './routes/app-routers';

function App() {
     return (
          <Router>
               <AppRouters />
          </Router>
     );
}

export default App;
